/**
 * Accesso route portale Gym in base a plan_allowed_paths da gym_billing (config admin).
 */

export const GYM_CORE_PATHS = [
    '/gym',
    '/gym/members',
    '/gym/members-draft',
    '/gym/add-member',
    '/gym/contabilita',
    '/gym/settings',
    '/gym/notifications',
    '/gym/feedback',
];

function normalizeGymPath(pathname) {
    return (pathname || '').replace(/\/$/, '') || '/gym';
}

/** /gym = solo dashboard (match esatto), altrimenti ogni /gym/* risulta consentito. */
export function gymPathMatchesAllowed(pathname, allowed) {
    const path = normalizeGymPath(pathname);
    const base = (allowed || '').replace(/\/$/, '');
    if (base === '/gym') {
        return path === '/gym';
    }
    return path === base || path.startsWith(`${base}/`);
}

export function isPathAllowedForGymPlan(pathname, allowedPaths) {
    if (!allowedPaths || !Array.isArray(allowedPaths) || allowedPaths.length === 0) {
        return true;
    }
    const path = normalizeGymPath(pathname);
    // Bozza layout clienti: stesso accesso di /gym/members
    if (path === '/gym/members-draft') {
        return allowedPaths.some((allowed) => gymPathMatchesAllowed('/gym/members', allowed));
    }
    return allowedPaths.some((allowed) => gymPathMatchesAllowed(path, allowed));
}

export function filterNavigationLinksByAllowedPaths(links, allowedPaths) {
    if (!allowedPaths || !Array.isArray(allowedPaths) || allowedPaths.length === 0) {
        return links;
    }
    if (!Array.isArray(links)) {
        return links;
    }

    return links
        .map((link) => {
            if (link.to && !isPathAllowedForGymPlan(link.to, allowedPaths)) {
                return null;
            }
            if (link.children?.length) {
                const children = link.children.filter(
                    (child) => child.to && isPathAllowedForGymPlan(child.to, allowedPaths),
                );
                if (children.length === 0) {
                    return null;
                }
                if (children.length === link.children.length) {
                    return link;
                }
                return { ...link, children };
            }
            return link;
        })
        .filter(Boolean);
}

/** @deprecated Usare filterNavigationLinksByAllowedPaths con plan_allowed_paths dall'API */
export const GYM_START_BLOCKED_PATHS = [
    '/gym/calendar',
    '/gym/courses',
    '/gym/bulk-enrollment',
    '/gym/import-csv',
    '/gym/statistics',
    '/gym/statistics-individual',
    '/gym/social',
    '/gym/email',
];

export function isGymStartBlockedPath(pathname) {
    const path = normalizeGymPath(pathname);
    return GYM_START_BLOCKED_PATHS.some(
        (blocked) => path === blocked || path.startsWith(`${blocked}/`),
    );
}

/** @deprecated Usare filterNavigationLinksByAllowedPaths */
export function filterNavigationLinksForGymPlan(links, gymPlan) {
    if (gymPlan !== 'start' || !Array.isArray(links)) {
        return links;
    }
    const blocked = new Set(GYM_START_BLOCKED_PATHS);
    return links
        .map((link) => {
            if (link.to && blocked.has(link.to)) {
                return null;
            }
            if (link.children?.length) {
                const children = link.children.filter((c) => !blocked.has(c.to));
                if (children.length === 0) {
                    return null;
                }
                if (children.length === link.children.length) {
                    return link;
                }
                return { ...link, children };
            }
            return link;
        })
        .filter(Boolean);
}
